export default "__VITE_ASSET__UOwyTsP4__"